import { view } from '@yola/ws-sdk';
import { breakpointKeys } from '../constants/breakpoints';

const getAttributeActionsToApply = (state = {}, options = {}) => {
  if (!Object.keys(state).length) {
    return [];
  }

  const actions = [];

  Object.keys(state).forEach((elementId) => {
    Object.keys(state[elementId]).forEach((attribute) => {
      const value = state[elementId][attribute][breakpointKeys.DEFAULT];

      if (value === undefined) {
        return;
      }

      if (typeof value === 'boolean') {
        if (value) {
          actions.push(view.actions.setElementAttribute(elementId, attribute, '', options));
        } else {
          actions.push(view.actions.removeElementAttribute(elementId, attribute, options));
        }

        return;
      }
      actions.push(view.actions.setElementAttribute(elementId, attribute, value, options));
    });
  });

  return actions;
};

export default getAttributeActionsToApply;
